/* KICKOFF base offers. Uses Kaching's public custom-element attributes;
   discount calculation and cart lines stay under Kaching's control. */
(() => {
  const BLOCKS = ['85480d82-3a6b-49a7-b8ec-b3aa37319268', '1fbb501c-3f52-4a65-b70b-232817043a7b'];
  const normalize = s => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  const team = p => normalize(p.title).split(/\s+bar\b/)[0];
  const motif = p => normalize(p.title).replace(/\s+oversized\s+(?:t-?shirt|shirt|hoodie).*$/, '');
  const isHoodie = p => /hoodie/i.test(p.title);
  // Default partner when the club has no counterpart (2026-09-22): Bayern Bär Heim.
  const isDefaultPartner = p => /^bayern\s+bar\s+heim\b/.test(normalize(p.title));
  const available = p => p.availableForSale && p.variants?.some(v => v.availableForSale);
  // German price format: 74,90 € (Kaching's own nodes are hidden once we render our own).
  const euro = n => (Math.round((n + Number.EPSILON) * 100) / 100).toFixed(2).replace('.', ',') + ' €';
  const euroShort = n => Math.abs(n - Math.round(n)) < 0.005 ? Math.round(n) + ' €' : euro(n);
  // Display name only; the Shopify product titles themselves are never changed.
  const shortName = t => String(t || '').replace(/\s*\bB(?:ä|a)r\b\s*/i, ' ').replace(/\s*oversized\s+(?:t-?shirt|shirt|hoodie)\s*$/i, '').replace(/\s+/g, ' ').trim();
  const kindOf = t => /hoodie/i.test(t) ? 'Hoodie' : 'Shirt';
  const sameUrl = (a, b) => String(a || '').replace(/^https?:/, '') === String(b || '').replace(/^https?:/, '');
  const setText = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
  const setValue = (node, text) => { if (node && node.nodeValue !== text) node.nodeValue = text; };
  const make = (tag, cls) => { const n = document.createElement(tag); n.className = cls; return n; };
  // Regular single-item price (EUR) from Kaching's product data; compare-at prices are deliberately ignored.
  const unitPrice = (p, variantId) => {
    const v = p?.variants?.find(x => x.id === variantId) || p?.variants?.find(x => x.availableForSale) || p?.variants?.[0];
    return v && v.price > 0 ? v.price / 100 : null;
  };
  // Price argument inside the selected offer. Returns [before, strong, after] or null.
  // Amounts come from the real offer and single prices, so the text can never contradict the price group.
  function hintFor({ hoodiePage, cross, quantity, total, single, save, double, sameTeam = true }) {
    if (!(total > 0) || !(single > 0) || !(save > 0)) return null; // only with a real saving
    const extra = total - single;
    const unit = hoodiePage ? 'Hoodie' : 'Shirt';
    if (cross) {
      if (hoodiePage) return extra > 0 ? [`Für nur ${euroShort(extra)} mehr`, sameTeam ? ' bekommst du das passende Shirt zu deinem Hoodie.' : ' bekommst du ein Shirt deiner Wahl zu deinem Hoodie.'] : null;
      return [sameTeam ? 'Dein Shirt und der passende Hoodie – ' : 'Dein Shirt und ein Hoodie deiner Wahl – ', `zusammen ${euro(save)} günstiger`, ' als einzeln.'];
    }
    if (quantity === 2) return extra > 0 ? [`Für nur ${euroShort(extra)} mehr`, ` als ein ${hoodiePage ? 'einzelner' : 'einzelnes'} ${unit} bekommst du 2 ${unit}s.`] : null;
    if (quantity === 3 && double > 0 && total - double > 0) return [`Für nur ${euroShort(total - double)} mehr`, hoodiePage ? ' als beim Doppelpass bekommst du einen dritten Hoodie.' : ' als beim Doppelpass bekommst du ein drittes Shirt.'];
    return null;
  }
  const norm3 = h => h ? (h.length === 3 ? h : ['', h[0], h[1]]) : null;
  // Display order: Einzelprodukt -> Doppelpass -> Matchday-Set -> Dreierkette.
  const rank = bar => bar.quantity === 1 ? 0 : (bar.discountValue || 9999);
  const read = (el, name, fallback) => { try { return JSON.parse(el.getAttribute(name)) ?? fallback; } catch { return fallback; } };
  // Public Shopify catalog supplies newly published crossover partners too.
  // Quantity-discount eligibility stays with Kaching's configured collection.
  let catalog = [];
  const catalogReady = (async () => {
    const products = [];
    for (let page = 1; page <= 10; page++) {
      const response = await fetch(`/products.json?limit=250&page=${page}`);
      if (!response.ok) throw new Error('Catalog unavailable');
      const batch = (await response.json()).products || [];
      products.push(...batch);
      if (batch.length < 250) break;
    }
    catalog = products.filter(p => /oversized.*(?:shirt|hoodie)/i.test(p.title)).map(p => ({
      id:p.id, title:p.title, handle:p.handle, url:`/products/${p.handle}`,
      image:p.images?.[0]?.src, availableForSale:p.variants.some(v=>v.available),
      options:p.options.map(o=>({name:o.name,defaultName:o.name,position:o.position,optionValues:o.values.map(v=>({name:v,defaultName:v,swatch:{image:null,color:null}}))})),
      sellingPlans:[], requiresSellingPlan:false,
      variants:p.variants.map(v=>({id:v.id,availableForSale:v.available,price:Math.round(Number(v.price)*100),compareAtPrice:null,options:[v.option1,v.option2,v.option3].filter(Boolean),image:p.images.find(i=>i.id===v.featured_image?.id)?.src || v.featured_image?.src || p.images?.[0]?.src,sellingPlans:[],inventoryPolicy:'continue'}))
    }));
    document.querySelectorAll('kaching-bundles-block').forEach(schedule);
  })().catch(() => {});
  const instances = new WeakMap();
  const write = (el, name, data) => { const next = JSON.stringify(data); if (el.getAttribute(name) !== next) el.setAttribute(name, next); };
  function prepare(el) {
    let state = instances.get(el);
    if (state?.busy) return;
    const block = read(el, 'deal-block', null), product = read(el, 'product', null);
    if (!block || !BLOCKS.includes(el.getAttribute('deal-block-id')) || !product || !el.hasAttribute('other-products') || !el.hasAttribute('collection-breaks-products')) return;
    if (!state) {
      state = { busy: false, initialized: false }; instances.set(el, state);
      el.addEventListener('change', () => schedule(el));
      el.addEventListener('variants-changed', () => schedule(el));
      el.addEventListener('click', event => {
        if (event.target.closest('.kaching-bundles__collection-product__remove-button')) state.changingMotif = true;
      }, true);
    }
    state.busy = true;
    try {
      const config = read(el, 'config', null);
      if (config && !config.ignoreDeselect) { config.ignoreDeselect = true; write(el, 'config', config); }
      const others = [...new Map([...catalog, ...read(el, 'other-products', [])].map(p=>[p.id,p])).values()];
      const collection = read(el, 'collection-breaks-products', []);
      const same = collection.filter(p => available(p) && isHoodie(p) === isHoodie(product));
      const seen = new Set();
      const opposite = others.filter(p => available(p) && isHoodie(p) !== isHoodie(product) && !seen.has(p.id) && seen.add(p.id));
      const partners = opposite.slice().sort((a, b) => Number(motif(b) === motif(product)) - Number(motif(a) === motif(product)) || Number(team(b) === team(product)) - Number(team(a) === team(product)) || a.title.localeCompare(b.title));
      const sameTeam = partners.length > 0 && team(partners[0]) === team(product);
      let cross = block.dealBars.find(b => b.dealBarType === 'mix-and-match');
      if (cross && !state.originalCross) state.originalCross = JSON.parse(JSON.stringify(cross));
      // Partner data arrives asynchronously. Restore only an actual app offer,
      // never manufacture a crossover when Kaching has not supplied one.
      if (!cross && partners.length && state.originalCross) {
        cross = JSON.parse(JSON.stringify(state.originalCross));
        block.dealBars.push(cross);
      }
      const hoodie = isHoodie(product);
      const unit = hoodie ? 'Hoodie' : 'Shirt';
      const single = unitPrice(product, Number(el.getAttribute('current-variant-id'))) ?? (hoodie ? 59.9 : 34.9);
      const savings = {};
      if (cross) {
        if (partners.length) {
          const slot = cross.bundleProducts[1];
          const ownSlot = cross.bundleProducts[0];
          if (ownSlot && same.length) {
            ownSlot.productGID = `gid://shopify/Product/${product.id}`;
            ownSlot.variantGIDs = null;
            ownSlot.selectedProducts = same.map(p => ({ id: `gid://shopify/Product/${p.id}`, variantGIDs: null }));
          }
          const merged = [...new Map([...others, ...same].map(p => [p.id,p])).values()];
          write(el, 'other-products', merged);
          if (slot) {
            slot.productGID = `gid://shopify/Product/${partners[0].id}`;
            slot.variantGIDs = null;
            cross.buttonText = 'Motiv ändern';
            slot.selectedProducts = partners.map(p => ({ id: `gid://shopify/Product/${p.id}`, variantGIDs: null }));
          }
          // Composition is shown once, by the theme. Kaching's own label stays empty.
          cross.label = '';
          const partnerPrice = unitPrice(partners[0]) ?? (hoodie ? 34.9 : 59.9);
          if (cross.discountType === 'specific' && cross.discountValue > 0) savings[cross.id] = { sum: single + partnerPrice, save: single + partnerPrice - cross.discountValue };
          const crossHint = hintFor({ hoodiePage: hoodie, cross: true, quantity: 2, total: cross.discountValue, single, save: savings[cross.id]?.save, sameTeam });
          cross.subtitle = crossHint ? crossHint.join('') : (hoodie ? '1 Hoodie + 1 Shirt' : '1 Shirt + 1 Hoodie');
        } else block.dealBars = block.dealBars.filter(b => b !== cross);
      }
      block.dealBars.sort((a, b) => rank(a) - rank(b));
      if (block.collectionBreaks) {
        block.collectionBreaks.autoFillNotChosenItems = true;
        block.collectionBreaks.buttonText = 'Motiv ändern';
        block.collectionBreaks.productPhotoSize = 44;
      }
      if (block.chooseProductModal) {
        block.chooseProductModal.heading = 'Wähle dein Motiv';
        block.chooseProductModal.showSearchField = true;
        block.chooseProductModal.subtitle = 'Wähle dein Motiv, deine Farbe und Größe.';
        block.chooseProductModal.buttonText = 'Übernehmen';
      }
      block.mixAndMatchChooseProductModal = {
        buttonSize: 16, textSize: 14, productPhotoSize: 100,
        overlayColor: {red:0,green:0,blue:0,alpha:0.5},
        priceColor: {red:0,green:0,blue:0,alpha:1},
        compareAtPriceColor: {red:128,green:128,blue:128,alpha:1},
        textColor: {red:0,green:0,blue:0,alpha:1},
        buttonColor: {red:0,green:0,blue:0,alpha:1},
        buttonTextColor: {red:255,green:255,blue:255,alpha:1},
        ...block.mixAndMatchChooseProductModal,
        heading: 'Wähle dein Motiv', buttonText: 'Übernehmen'
      };
      block.dealBars.forEach(bar => {
        if (bar.quantity === 2 || bar.quantity === 3) {
          bar.title = bar.quantity === 2 ? (hoodie ? '2 Hoodies' : 'Doppelpack · 2 Shirts') : (hoodie ? '3 für 2 · 3 Hoodies' : '3 für 2 · 3 Shirts');
          const each = euro(bar.discountValue / bar.quantity);
          bar.subtitle = bar.quantity === 2 ? (hoodie ? 'Dein zweiter Hoodie zum halben Preis.' : 'Dein zweites Shirt für nur 20 € dazu.') : `Nur ${each} pro ${unit}. Dein ${hoodie ? 'dritter' : 'drittes'} geht auf uns.`;
          bar.label = ''; // savings are shown in the price group
          if (bar.discountType === 'specific' && bar.discountValue > 0) savings[bar.id] = { sum: single * bar.quantity, save: single * bar.quantity - bar.discountValue };
        }
        if (bar.quantity === 1) { bar.subtitle = ''; bar.label = ''; }
      });
      Object.keys(savings).forEach(id => { if (!(savings[id].save > 0)) delete savings[id]; });
      write(el, 'collection-breaks-products', same.length ? same : [product]);
      write(el, 'deal-block', block);
      if (!state.initialized) {
        el.setAttribute('selected-deal-bar-id', block.preselectedDealBarId);
        state.initialized = true;
      }
      el.classList.add('ko-bundle-base');
      state.pool = same; state.product = product; state.partners = partners; state.block = block; state.savings = savings; state.single = single; state.sameTeam = sameTeam;
      decorate(el, state);
    } finally { state.busy = false; }
  }
  // Native quantity breaks lock slot zero. This accessible picker updates the
  // public product/current-variant attributes; Kaching still owns cart items and discounts.
  function chooseFirst(el, state, trigger) {
    const dialog = make('dialog', 'ko-first-motif');
    const heading = make('h2', ''); heading.textContent = 'Wähle dein erstes Motiv';
    const close = make('button', 'ko-first-close'); close.type='button'; close.textContent='Schließen';
    const search = document.createElement('input'); search.type='search'; search.placeholder='Motiv suchen'; search.setAttribute('aria-label','Motiv suchen');
    const products = document.createElement('select'); products.setAttribute('aria-label','Motiv');
    const photo = document.createElement('img'); photo.alt='';
    const variants = document.createElement('div'); variants.className='ko-first-variants';
    const apply = make('button', 'ko-first-apply'); apply.type='button'; apply.textContent='Motiv übernehmen';
    let selected=state.product; let options=[]; let variant;
    function renderVariants(){
      photo.src=selected.image; variants.replaceChildren();
      options=selected.options.map((o,index)=>{
        const label=document.createElement('label'); label.textContent=/size|größe/i.test(o.name)?'Größe':'Farbe';
        const select=document.createElement('select'); select.setAttribute('aria-label',label.textContent);
        [...new Set(selected.variants.filter(v=>v.availableForSale).map(v=>v.options[index]))].forEach(value=>{const option=new Option(({Black:'Schwarz',White:'Weiß'})[value]||value,value);select.add(option);});
        label.append(select);variants.append(label);select.addEventListener('change',validate);return select;
      }); validate();
    }
    function validate(){variant=selected.variants.find(v=>v.availableForSale&&options.every((s,i)=>s.value===v.options[i]));apply.disabled=!variant;if(variant?.image)photo.src=variant.image;}
    function renderProducts(){
      products.replaceChildren();
      state.pool.filter(p=>normalize(p.title).includes(normalize(search.value))).forEach(p=>products.add(new Option(shortName(p.title),String(p.id))));
      if([...products.options].some(o=>o.value===String(selected.id)))products.value=String(selected.id);
      else if(products.value)selected=state.pool.find(p=>String(p.id)===products.value);
      if(products.value)renderVariants();else{variants.replaceChildren();apply.disabled=true;}
    }
    search.addEventListener('input',renderProducts);
    products.addEventListener('change',()=>{selected=state.pool.find(p=>String(p.id)===products.value);renderVariants();});
    const cleanup=()=>{dialog.close();dialog.remove();trigger.focus();}; close.addEventListener('click',cleanup);
    dialog.addEventListener('cancel',event=>{event.preventDefault();cleanup();});
    apply.addEventListener('click',()=>{if(!variant)return;write(el,'product',selected);el.setAttribute('current-variant-id',String(variant.id));cleanup();schedule(el);});
    dialog.append(close,heading,search,products,photo,variants,apply);document.body.append(dialog);renderProducts();dialog.showModal();search.focus();
  }
  // Short item name inside an opened offer, e.g. "Shirt 1 · Augsburg Heim".
  function itemLabel(item, contentSelector, titleSelector, index) {
    const content = item.querySelector(contentSelector), title = item.querySelector(titleSelector);
    if (!content || !title) return;
    const full = title.textContent.trim();
    if (!full) return;
    const text = `${kindOf(full)}${index ? ' ' + index : ''} · ${shortName(full)}`;
    let node = content.querySelector('.ko-item-label');
    if (!node) { node = make('span', 'ko-item-label'); content.prepend(node); }
    setText(node, text);
    content.classList.add('ko-labeled');
  }
  function decorate(el, state) {
    const { product, partners, block, savings } = state;
    const currentVariant = Number(el.getAttribute('current-variant-id'));
    const imageFor = p => (p.variants?.find(v => v.id === currentVariant) || p.variants?.find(v => v.availableForSale))?.image || p.image;
    const hoodiePage = isHoodie(product);
    const unit = hoodiePage ? 'Hoodie' : 'Shirt';
    el.querySelectorAll('.kaching-bundles__bar').forEach(row => {
      const offer = block.dealBars.find(b => b.id === row.dataset.dealBarId);
      const main = row.querySelector('.kaching-bundles__bar-main');
      const content = row.querySelector('.kaching-bundles__bar-content');
      const left = row.querySelector('.kaching-bundles__bar-content-left');
      if (!offer || !main || !content || !left) return;
      const cross = offer.dealBarType === 'mix-and-match';
      const quantity = cross ? 2 : (offer.quantity || 1);
      row.classList.toggle('ko-bundle-solo', quantity === 1);
      row.classList.toggle('ko-bundle-cross', cross);
      row.classList.toggle('ko-bundle-badged', !!row.querySelector('.kaching-bundles__bar-most-popular'));
      // Small product tiles inside the offer header. They are hidden while the offer is open,
      // because the item rows below already carry a photo per article.
      const shown = cross ? [product, partners[0]].filter(Boolean) : Array.from({ length: Math.min(quantity, 3) }, () => product);
      const key = shown.map(p => p.id).join('+');
      let photos = row.querySelector('.ko-bundle-photos');
      if (photos && photos.dataset.key !== key) { photos.remove(); photos = null; }
      if (!photos) {
        photos = make('span', 'ko-bundle-photos'); photos.dataset.key = key; photos.setAttribute('aria-hidden', 'true');
        shown.forEach((p, i) => {
          if (i && cross) { const plus = make('span', 'ko-bundle-plus'); plus.textContent = '+'; photos.append(plus); }
          const tile = make('span', 'ko-bundle-tile');
          const img = document.createElement('img');
          img.src = imageFor(p); img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
          tile.append(img); photos.append(tile);
        });
      }
      const pricing = row.querySelector('.kaching-bundles__bar-pricing');
      if (pricing && (photos.parentElement !== content || photos.nextElementSibling !== pricing)) content.insertBefore(photos, pricing);
      [...photos.querySelectorAll('img')].forEach((img, i) => { const src = imageFor(shown[i]); if (src && !sameUrl(img.src, src)) img.src = src; });
      // One compact meta line under the offer name; the per-item price is its strong part.
      const countText = cross ? (hoodiePage ? '1 Hoodie + 1 Shirt' : '1 Shirt + 1 Hoodie') : '';
      const strongText = !cross && quantity > 1 && offer.discountValue > 0 ? `${euro(offer.discountValue / quantity)} pro ${unit}` : '';
      let meta = left.querySelector('.ko-bundle-meta');
      if (countText || strongText) {
        if (!meta) { meta = make('span', 'ko-bundle-meta'); meta.append(document.createTextNode(''), make('strong', 'ko-bundle-meta__strong')); left.append(meta); }
        setValue(meta.firstChild, countText);
        setText(meta.lastChild, strongText);
        left.classList.add('ko-metaed');
      } else if (meta) { meta.remove(); left.classList.remove('ko-metaed'); }
      // Price group: total, green savings, struck sum of the regular single prices.
      const info = savings[offer.id];
      const total = offer.discountType === 'specific' && offer.discountValue > 0 ? offer.discountValue : (!cross && quantity === 1 ? state.single : null);
      if (pricing) {
        let box = pricing.querySelector('.ko-bundle-pricebox');
        if (total == null) { if (box) box.remove(); pricing.classList.remove('ko-has-price'); }
        else {
          if (!box) { box = make('span', 'ko-bundle-pricebox'); box.append(make('span', 'ko-bundle-total')); pricing.prepend(box); }
          pricing.classList.add('ko-has-price');
          setText(box.querySelector('.ko-bundle-total'), euro(total));
          let save = box.querySelector('.ko-bundle-save'), sum = box.querySelector('.ko-bundle-sum');
          if (info) {
            if (!save) { save = make('span', 'ko-bundle-save'); box.append(save); }
            setText(save, `Du sparst ${euro(info.save)}`);
            if (!sum) { sum = make('span', 'ko-bundle-sum'); sum.append(document.createTextNode('Einzeln '), document.createElement('s')); box.append(sum); }
            setText(sum.lastChild, euro(info.sum));
          } else { if (save) save.remove(); if (sum) sum.remove(); }
        }
      }
      // Price argument inside the offer; CSS shows it only while the offer is selected (no extra banner).
      const doubleBar = block.dealBars.find(b => b.dealBarType !== 'mix-and-match' && b.quantity === 2 && b.discountType === 'specific' && b.discountValue > 0);
      const hint = quantity > 1 && offer.subtitle ? ['', offer.subtitle, ''] : null;
      let note = row.querySelector('.ko-bundle-hint');
      if (hint) {
        if (!note) { note = make('span', 'ko-bundle-hint'); note.append(document.createTextNode(''), document.createElement('strong'), document.createTextNode('')); }
        if (note.previousElementSibling !== main) main.after(note);
        setValue(note.firstChild, hint[0]);
        setText(note.children[0], hint[1]);
        setValue(note.lastChild, hint[2]);
      } else if (note) note.remove();
      row.classList.toggle('ko-bundle-has-hint', !!hint);
      // Short, readable item names; the real Shopify product titles stay untouched.
      const items = [...row.querySelectorAll('.kaching-bundles__collection-product')];
      items.forEach((item, i) => itemLabel(item, '.kaching-bundles__collection-product__content', '.kaching-bundles__collection-product__title', items.length > 1 ? i + 1 : 0));
      if (items[0] && quantity > 1 && !items[0].querySelector('.ko-first-change')) {
        const button=make('button','ko-first-change');button.type='button';button.textContent='Motiv ändern';button.addEventListener('click',()=>chooseFirst(el,instances.get(el),button));items[0].append(button);
      }
      row.querySelectorAll('.kaching-bundles__mix-and-match-product').forEach(item => itemLabel(item, '.kaching-bundles__mix-and-match-product__content', '.kaching-bundles__mix-and-match-product__title', 0));
    });
    el.querySelectorAll('.kaching-bundles__collection-product__remove-button').forEach(button => {
      if (button.getAttribute('aria-label') !== 'Motiv ändern') { button.setAttribute('aria-label', 'Motiv ändern'); button.textContent = 'Motiv ändern'; }
    });
    const optionNames = { Color: 'Farbe', Size: 'Größe', Black: 'Schwarz', White: 'Weiß' };
    el.querySelectorAll('select option,.kaching-bundles__bar-variant-names span').forEach(node => {
      const translated = optionNames[node.textContent.trim()];
      if (translated) node.textContent = translated;
    });
    el.querySelectorAll('select').forEach(select => {
      const translated = optionNames[select.getAttribute('aria-label')];
      if (translated) select.setAttribute('aria-label', translated);
    });
    if (state.changingMotif) {
      const choose = el.querySelector('.kaching-bundles__bar--selected .kaching-bundles__collection-product__choose-product-button');
      if (choose) { state.changingMotif = false; choose.click(); }
    }
  }
  // App chooser dialogs are portalled to body. Translate display text only;
  // never alter native option values, variant IDs or product data.
  function translateChooser() {
    const words = {Color:'Farbe', Size:'Größe', Choose:'Übernehmen', Black:'Schwarz', White:'Weiß'};
    document.querySelectorAll('.kaching-bundles__mix-and-match-choose-product, .kaching-bundles__choose-product').forEach(dialog => {
      dialog.querySelectorAll('label, button, option, span').forEach(node => {
        if (node.children.length) return;
        const value = words[node.textContent.trim()];
        if (value) node.textContent = value;
      });
      dialog.querySelectorAll('select').forEach(select => {
        const value = words[select.getAttribute('aria-label')];
        if (value) select.setAttribute('aria-label', value);
      });
    });
  }
  const queue = new Set(); let scheduled = false;
  const schedule = el => { queue.add(el); if (!scheduled) { scheduled = true; queueMicrotask(() => { scheduled = false; const els = [...queue]; queue.clear(); els.forEach(prepare); }); } };
  new MutationObserver(records => {
    translateChooser();
    records.forEach(r => {
      if (r.type === 'attributes') { if (r.target.matches?.('kaching-bundles-block')) schedule(r.target); return; }
      const parent = (r.target.nodeType === 1 ? r.target : r.target.parentElement)?.closest?.('kaching-bundles-block');
      if (parent) schedule(parent);
      r.addedNodes?.forEach(n => { if (n.nodeType !== 1) return; if (n.matches('kaching-bundles-block')) schedule(n); n.querySelectorAll('kaching-bundles-block').forEach(schedule); });
    });
  }).observe(document.documentElement, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['deal-block', 'product', 'other-products', 'collection-breaks-products', 'current-variant-id', 'selected-deal-bar-id'] });
  document.querySelectorAll('kaching-bundles-block').forEach(schedule);
})();
